import Component from '@bythepixel/component-loader';
import GlideSlider from '../base';

// Refer to https://glidejs.com/docs/options/
const glideOptions = {
  type: 'slider',
  rewind: false,
  animationDuration: 0,
};

const selectors = {
  slideSelector: '[data-testimonial-slider-slide]',
  leftArrowSelector: '[data-testimonial-slider-arrow-left]',
  rightArrowSelector: '[data-testimonial-slider-arrow-right]',
  slideIndicatorSelector: '[data-testimonial-slider-indicator]',
  slideIndicatorActiveClass: 'section-carousel-testimonials__nav-btn--active',
};

export default class SectionTestimonialSlider extends Component {
  static selector = '[data-comp-testimonial-slider]';
  static loaderPriority = 'in-view';

  constructor(containerEl) {
    super(containerEl);

    this.slider = new GlideSlider(containerEl, glideOptions, selectors);
    this.sliderGlideInstance = this.slider.getGlideSlider();

    // Run these events after mounting the slide
    // And after transitioning between two slides
    this.sliderGlideInstance.on(['mount.after', 'run.after'], () => {
      const slideWidth = this.slider.getSliderWidth();

      this.slider.adjustSlideWidth(slideWidth);
      this.slider.handleArrowButtonState();
    });

    // Run this event before transitioning the slide
    this.sliderGlideInstance.on('run', () => {
      this.slider.handleSlideIndicatorActiveState();
    });

    this.sliderGlideInstance.mount();
  }
}
